import { animation, style, animate, trigger, transition, useAnimation, state, query, sequence, stagger, keyframes } from '@angular/animations'

export const openClose = trigger('openClose', [
    state('closed', style({
        transform: 'rotate(0)',
    })),
    state('open', style({
        transform: 'rotate(-180deg)',
    })),
    transition('* => open', [
        animate('510ms ease-out')
    ]),
    transition('* => closed', [
        animate('500ms ease-in')
    ]),
])

export const expandCollapse = trigger('expandCollapse', [
    transition(':enter', [
        query(".collapsible", [
            style({ height: 0, overflow: "hidden" }),
            animate("510ms", style({ height: "*" })),
        ], { optional: true }),
    ]),
    transition(':leave', [
        query(".collapsible", [
            style({ height: '*', overflow: "hidden" }),
            animate("510ms", style({ height: 0 }))
        ], { optional: true }),
    ])
])

export const optionGroupTrigger = trigger('optionGroupTrigger', [
    transition(':enter', [
        style({ height: 0, width: 0, overflow: "hidden" }),
        animate("200ms", style({ height: "*", width: "*" })),
    ]),
    transition(':leave', [
        style({ height: '100%', width: '100%', overflow: "hidden" }),
        animate("200ms", style({ height: 0, width: 0 })),
    ])
])

export const pulseAnimation = animation([
    style({ transform: 'scale(1)' }),
    animate(
        '{{ timings }}',
        keyframes([
            style({ transform: 'scale(1)', offset: 0 }),
            style({ transform: 'scale({{ scale }})', offset: 0.5 }),
            style({ transform: 'scale(1)', offset: 1 })
        ])
    )
])